import axios from "@/plugins/axios";
import { ResponseError } from "@/app/shared/utils/httpManager";

export async function generateTtsPreview(data) {
  try {
    const response = await axios.post("/strategies/tts/preview/", data, {
      responseType: "blob",
    });

    if (response.data?.type?.includes("application/json")) {
      const json = JSON.parse(await response.data.text());
      return json.audio_url || json.audio || json.url || json.file;
    }

    return response.data;
  } catch (error) {
    throw new ResponseError(
      error?.response || {
        status: 0,
        data: { message: error?.message || "No se pudo generar el audio" },
        config: error?.config,
      }
    );
  }
}
